import { action, observable } from 'mobx';
import URLS from '../../constant/urls';
import { SelectCountryStoreModel } from '.';
import {fetch} from '../../utils/fetch'
class BindNotice {
    public rootStore: any;

    // 展示搜索组件
    @observable
    public isSearchPage = false;

    // input Value
    @observable
    public searchData = '';

    @observable
    public searchResult: string[] = [];

    @observable
    public searchOfloading = false;

    @observable
    public visAlert = false;

    public debounceOfFetchDataOfInput: any;

    public constructor(rootStore: SelectCountryStoreModel) {
        this.rootStore = rootStore;
        this.debounceOfFetchDataOfInput = this.debounce(this.fetchDataOfInput, 500);
    }

    @action
    public toggleSearchPage = (searchPage: boolean) => {
        this.isSearchPage = searchPage;
    };

    @action
    public onTextChange = (searchData: string) => {
        this.searchOfloading = true;
        this.searchData = searchData;
        this.debounceOfFetchDataOfInput(searchData);
    };

    @action
    public changeVisAlert = (status: boolean) => {
        this.visAlert = status;
    };

    public fetchDataOfInput = async (input: any) => {
        try {
            const response = await fetch({
                url: URLS.autoSearch,
                method: 'GET',
                body: {
                    input
                }
            });
            const { errcode, data } = response;
            if (errcode === 200) {
                this.searchResult = data.result;
                this.searchOfloading = false;
            } else {
                this.visAlert = true;
                this.searchOfloading = false;
            }
        } catch (err) {
            this.visAlert = true;
            this.searchOfloading = false;
        }
    };

    public debounce = (method: (params: any) => void, delay: number) => {
        let timer: any = null;
        return (args: any) => {
            if (args) {
                timer && clearTimeout(timer);
                timer = setTimeout(() => {
                    method(args);
                }, delay);
            } else {
                timer && clearTimeout(timer);
                this.searchResult = [];
                this.searchOfloading = false;
            }
        };
    };
}

export default BindNotice;
